/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */

import type { PreloadedQuery } from 'react-relay';
import { fg } from '@atlassian/jira-feature-gating';
import type { RouteResource } from '@atlassian/react-resource-router';
import SidebarQuery, {
	type JsmProjectMenuWrapper_SidebarQuery,
} from '@jira/navigation-apps__sidebar-nav4-sidebars-content-projects-jsm-project-menu/src/ui/project-menu/__generated__/JsmProjectMenuWrapper_SidebarQuery.graphql';
import { createRelayResource } from '@jira/platform__graphql-relay-utils/src/services/resources/index.tsx';
import { getProjectKeyId } from '@jira/router-resources__utils/src/getProjectKeyId.tsx';
import { withGiraAggAnonSsrFix } from '../../../common/utils.tsx';

export const getQuery: Parameters<
	typeof createRelayResource<JsmProjectMenuWrapper_SidebarQuery>
	// oxlint-disable-next-line no-explicit-any
>[0]['getQuery'] = ({ match, query }: { match: any; query: any }, resourceContext: any) => {
	const cloudId = resourceContext?.tenantContext?.cloudId ?? '';
	const accountId = resourceContext?.tenantContext?.atlassianAccountId ?? '';
	const includeWorkforceTeamAccess = fg('jsm_workforce_horizontal_nav')
		? false
		: Boolean(accountId) && fg('jsm_workforce_permission');
	let { projectKey } = getProjectKeyId(match, query);
	projectKey = projectKey ?? '';

	return {
		options: {
			fetchPolicy: 'store-and-network' as const,
		},
		parameters: SidebarQuery,
		variables: {
			cloudId,
			projectKey,
			workforceProjectKey: projectKey,
			accountIds: includeWorkforceTeamAccess ? [accountId] : [],
			includeWorkforceTeamAccess,
		},
	};
};

export const jsmProjectMenuContentSidebarResource: RouteResource<
	PreloadedQuery<JsmProjectMenuWrapper_SidebarQuery, Record<string, unknown>>
> = withGiraAggAnonSsrFix(
	createRelayResource<JsmProjectMenuWrapper_SidebarQuery>({
		type: 'JSM_PROJECT_MENU_CONTENT_SIDEBAR_QUERY',
		getQuery,
	}),
);
